<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-12-04 17:48:30
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2024-03-28 13:08:49
 * @FilePath: \miniproweb\src\views\Echart\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="echartBody">
    <div class="EchartBox" id="myChart"></div>
    <div class="tableBox">
      <el-table :data="tableData" style="width: 100%" height="400">
        <el-table-column prop="time" label="日期" width="180"></el-table-column>
        <el-table-column prop="data" label="数据" width="180"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      echartsBox: null,
      tableData: []
    };
  },
  mounted() {
    this.getData();
    console.log(this.$route.params.sta);
    console.log(this.$route.params.type);
  },
  methods: {
    getData() {
      this.$axios({
        method: "get",
        url: `http://120.79.183.250:3093/InterfaceServices/HourDataService/queryHourListByStationAndDates?endDate=${moment().format(
          "YYYY-MM-DD"
        )} 20:00:00&startDate=${moment().format(
          "YYYY-MM-DD"
        )} 08:00:00&stationNum=${this.$route.params.sta.stationNum}`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(res => {
        // this.tableData = res.data.data;
        console.log(res.data.data);
        this.drawLine(res.data.data);
      });
    },
    drawLine(data) {
      // 基于刚刚准备好的 DOM 容器，初始化 EChart 实例
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      // 绘制图表
      let timeList = [];
      let dataList = [];
      let typeData = "temAvg";
      if (this.$route.params.type == "温度") {
        typeData = "temAvg";
      } else if (this.$route.params.type == "降水") {
        typeData = "pre1h";
      } else if (this.$route.params.type == "湿度") {
        typeData = "rhuAvg";
      } else if (this.$route.params.type == "风速") {
        typeData = "winSAvg2mi";
      }
      data.map(item => {
        this.tableData.push({
          time: item.dateTime,
          data: item[typeData]
        });
        timeList.push(item.dateTime);
        dataList.push(item[typeData]);
      });
      console.log(dataList);
      myChart.setOption({
        title: {
          show: true, //显示策略，默认值true,可选为：true（显示） | false（隐藏）
          text: `${this.$route.params.sta.stationName}${this.$route.params.type}发展趋势图`, //主标题文本，'\n'指定换行
          x: "center"
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: timeList
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            data: dataList,
            type: "line",
            areaStyle: {}
          }
        ]
      });
    }
  }
};
</script>

<style>
.echartBody {
  height: 100vh;
  width: 100vw;
  /* background-color: rgb(29, 198, 142); */
}
.EchartBox {
  height: 300px;
  width: 100%;
}
.tableBox {
  height: 400px;
  width: 100%;
  /* background-color: aqua; */
}
</style>